import { ApiClient, type ApiClientOptions } from '@/infra/api-client'
import type {
  CsDeskResponse,
  RelationManagerResource,
} from '@/features/relation-manager/api/resources/relation-manager'

/**
 * Collection of APIs for CS Desk.
 */
export class CsDeskApi {
  readonly relationManagers

  constructor(options: ApiClientOptions) {
    this.relationManagers = new RelationManagerApi(options)
  }
}

export class RelationManagerApi extends ApiClient {
  get(
    jobId: string,
    signal?: AbortSignal,
  ): Promise<CsDeskResponse<RelationManagerResource>> {
    return this._get(`api/v1/rms/job/${encodeURIComponent(jobId)}`, undefined, {
      signal,
    })
  }
}
